import type { PillStatus } from '../primitives/Pill';
import { pillStatus } from '../../lib/models/dashboard';
import type { CellValue, Column } from '../Table';

export function formatCell(value: CellValue, col: Column): string {
  if (value == null || value === '') return '';
  if (Array.isArray(value)) {
    if (col.options) {
      return value
        .map((v) => col.options!.find((o) => o.value === v)?.label ?? v)
        .join(', ');
    }
    return value.join(', ');
  }
  if (col.options) {
    return (
      col.options.find((o) => o.value === String(value))?.label ?? String(value)
    );
  }
  return String(value);
}

/** Map a stored cell value to a Pill variant for lifecycle/status columns. */
export function pillStatusForCell(columnKey: string, value: CellValue): PillStatus {
  const raw =
    value == null || value === ''
      ? ''
      : typeof value === 'string'
        ? value
        : String(value);
  if (columnKey === 'lifecycle' || columnKey === 'status') {
    return pillStatus(raw);
  }
  return pillStatus(raw);
}

export function isAlwaysVisibleEditor(column: Column): boolean {
  if (column.editable === false) return false;
  return (
    column.type === 'single_select' ||
    column.type === 'person' ||
    column.type === 'date' ||
    column.type === 'multi_select'
  );
}
